import React, { useContext } from 'react';
import { IntegrationSettingsInput } from '../../../../../../../types/integration_settings';
import { ActionModalBody, ActionModalFooter } from '../../../../../../components/Modal/templates/ActionModal';
import { Divider } from '../../../../../../components/Divider';
import { CancelButton, Button } from '../../../../../../components/Button';
import { t } from '../../../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { UserContext } from '../../../../../../../context/UserContext';
import { useToast } from '../../../../../../../providers/ToastProvider';
import { BusinessCentralRequest } from '../../../../../../../requests/businessCentral.request';
import { useRequest } from '../../../../../../../requests/common/requestHook';

interface BusinessCentralIntegrationPaneProps {
  input: IntegrationSettingsInput;
  setInput: (input: IntegrationSettingsInput) => void;

  loading: boolean;

  handleCancel: () => void;
}

export default function TeamleaderIntegrationInfoPane({
  input,
  setInput,
  loading,
  handleCancel,
}: BusinessCentralIntegrationPaneProps) {
  const { showToast } = useToast();

  const { companyUsers } = useContext(UserContext);

  const [importProductMasterData, { loading: loadingReferenceData }] = useRequest(
    BusinessCentralRequest.importProductMasterData,
  );

  const [importPurchaseOrders, { loading: loadingPurchaseOrders }] = useRequest(
    BusinessCentralRequest.importPurchaseOrders,
  );

  const [importStockLocations, { loading: loadingStockLocations }] = useRequest(
    BusinessCentralRequest.importStockLocations,
  );

  const isLoading = loading || loadingReferenceData || loadingPurchaseOrders || loadingStockLocations;

  return (
    <>
      <ActionModalBody>
        <div className='flex flex-col gap-2'>
          <div className='flex gap-2'>
            <Button
              disabled={isLoading}
              loading={loadingReferenceData}
              onClick={() => importProductMasterData({ settingId: input.id })}
              text={t(TranslationKey.syncItems).plural.label}
            />
            <Button
              disabled={isLoading}
              loading={loadingPurchaseOrders}
              onClick={() => importPurchaseOrders({ settingId: input.id })}
              text={t(TranslationKey.syncPurchaseOrders).plural.label}
            />
            <Button
              disabled={isLoading}
              loading={loadingStockLocations}
              onClick={() => importStockLocations({ settingId: input.id })}
              text={t(TranslationKey.syncStorageLocation).plural.label}
            />
          </div>
        </div>
      </ActionModalBody>
      <Divider />
      <ActionModalFooter>
        <div className='flex justify-between gap-2'>
          {/* <DeleteButton loading={loading} disabled={isLoading} onClick={handleDelete} /> */}
          <CancelButton disabled={isLoading} onClick={handleCancel} />
        </div>
      </ActionModalFooter>
    </>
  );
}
